webpackJsonp([255399219210232],{

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(80);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var videos = [{
	  title: 'SCION demo',
	  id: 'GbP3_b8GVbM',
	  start: 700
	}, {
	  title: 'SCION demo',
	  id: 'G7ADiXTP-LM'
	}, {
	  title: 'SCION demo',
	  id: 'Pg9tYuJN6BI',
	  start: 1025
	}, {
	  title: 'SCION demo',
	  id: 'zTGYmzVzW6M'
	}, {
	  title: 'SCION demo',
	  id: 'IxAASoas1fY'
	}, {
	  title: 'Morse hardware demo',
	  id: '7S-blsAqt_U'
	}];
	
	var embedUrl = function embedUrl(video) {
	  return 'https://www.youtube.com/embed/' + video.id + (video.start ? '?start=' + video.start : '');
	};
	
	var VideoEmbed = function VideoEmbed(_ref) {
	  var video = _ref.video;
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-md-6', style: { marginBottom: '2rem' } },
	    _react2.default.createElement(
	      'h3',
	      null,
	      video.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', background: '#111' } },
	      _react2.default.createElement('iframe', {
	        title: video.title + ' ' + video.id,
	        src: embedUrl(video),
	        style: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 },
	        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
	        allowFullScreen: true
	      })
	    )
	  );
	};
	
	var ExampleVideos = function ExampleVideos() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'h1',
	      { style: { textAlign: 'center', padding: '1em 0' } },
	      'Example Videos'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A collection of SCION and SCXML example videos, including the Morse code hardware demo.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/examples' },
	        'Back to examples'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      videos.map(function (video) {
	        return _react2.default.createElement(VideoEmbed, { key: video.id + '-' + (video.start || 0), video: video });
	      })
	    )
	  );
	};
	
	exports.default = ExampleVideos;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-videos-js-64dfba5245a8900f3bbc.js